import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  GreyGrey80,
  Primary13Regular,
  Primary13SemiBold,
  useNotifications,
  SimpleModal,
  Box,
  Flex
} from '@sequencehq/core-components'
import { useForm } from '@sequencehq/utils'
import { required } from '@sequencehq/utils/validation'
import { FC, useState } from 'react'
import { CustomerSelect } from '../../CustomerSelect'

export const LinkAliasToCustomerModal: FC<{
  alias: string
  onClose: () => void
  onSuccess: () => void
}> = ({ alias, onClose, onSuccess }) => {
  const { displayNotification } = useNotifications()
  const [showValidationErrors, setShowValidationErrors] = useState(false)
  const form = useForm({
    value: {
      customerId: ''
    },
    showValidationErrors,
    fieldConfiguration: [
      {
        property: 'customerId',
        validation: [required]
      }
    ]
  })
  const linkAliasMutation = useMutation(
    dashboard20240730Client.postCustomerAlias,
    {
      onSuccess: () => {
        displayNotification('Alias linked to customer', {
          type: 'success'
        })
      },
      onError: () => {
        displayNotification('Could not link alias to customer', {
          type: 'error'
        })
      }
    }
  )

  const handleOnSubmit = async () => {
    setShowValidationErrors(true)
    if (!form.queries.isValid) {
      return false
    }

    const res = await linkAliasMutation.mutateAsync({
      customerId: form.fields.customerId.value,
      value: alias
    })

    if (res) {
      onSuccess()
      return true
    }

    return false
  }

  return (
    <SimpleModal
      isOpen
      data-testid="linkAliasToCustomer.modal"
      title="Link customer to alias"
      onSubmit={handleOnSubmit}
      onClose={onClose}
      submittingButtonText="Linking..."
      submitButtonText="Link"
      cancelButtonText="Cancel"
    >
      <Flex
        {...Primary13Regular}
        gap="8px"
        flexDirection="column"
        marginBottom="16px"
      >
        <Box {...Primary13SemiBold} userSelect="none" color={GreyGrey80}>
          Alias
        </Box>
        <Box>{alias}</Box>
      </Flex>
      <Flex
        {...Primary13Regular}
        gap="8px"
        flexDirection="column"
        marginBottom="16px"
      >
        <Box {...Primary13SemiBold} userSelect="none" color={GreyGrey80}>
          Customer
        </Box>
        <CustomerSelect
          data-testid="linkAliasToCustomer.modal.customer"
          value={form.fields.customerId.value}
          onChange={newCustomer => form.fields.customerId.onChange(newCustomer)}
          validationErrors={form.fields.customerId.validationErrors}
        />
      </Flex>
    </SimpleModal>
  )
}
